<template>
	<tr>
		<td class="text-sm fw-bold align-middle">
			<div class="vstack lh-xs" v-tooltip:top="productsDetail">
				<div class="h5 fw-bold lh-xs" v-if="proposal.name">{{ proposal.name }}</div>
				<div class="text-muted">{{ (productsCount == 1) ? '1 producto' : `${productsCount} productos` }}</div>
				<div class="text-xs text-muted">{{ dateDiff }}</div>
			</div>
		</td>
		<td class="text-sm text-end align-middle" width="140">
			<a href="javascript:void(0);" class="link-primary me-3" @click="copy" v-if="proposal?.data?.url" v-tooltip:left="'Copiar link'"><i class="bi bi-copy"></i></a>
			<span class="badge rounded-pill text-xs" :class="statusInfo.class" v-tooltip:left="statusInfo.description" v-if="statusInfo">{{ statusInfo.title }}</span>
			<span class="badge rounded-pill text-xs bg-gray-200" v-else>{{ proposal.status }}</span>
		</td>
	</tr>
</template>

<script>
	import { computed, inject } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';
	import { useToast } from 'vue-toastification';

	export default {
		props: {
			proposal: Object
		},
		setup(props) {
			const $env = inject('$env');
			const toast = useToast();
			const dateDiff = moment(props.proposal.created_at).fromNow();
			const productsCount = computed(() => _.sumBy(props.proposal.products, 'pivot.quantity'));
			const productsDetail = computed(() => _.map(props.proposal.products, (product) => `${product.pivot.quantity}u. ${(product.extras?.code) ? `(${product.extras.code}) ` : ''}${product.name}`).join('<br>'));
			const statusInfo = computed(() => {
				if(props.proposal.status in $env.MODEL.Proposal.statuses) return $env.MODEL.Proposal.statuses[props.proposal.status];
				else return null;
			});

			const copy = async () => {
				try {
					await navigator.clipboard.writeText(props.proposal?.data?.url);
					toast.success('¡Link copiado con éxito!');
				}catch {
					toast.error('Error al copiar link');
				}
			}

			return { dateDiff, productsCount, productsDetail, statusInfo, copy };
		}
	}
</script>